import type { To } from "react-router-dom";
import { resolvePath } from "react-router-dom";

/** URL segments for consultation screen tabs (EN + legacy PT). */
const MEDICAL_RECORD_TAB_SLUGS = new Set([
  "record",
  "exams",
  "prescriptions",
  "applications",
  "terms",
  "novo",
  "exames",
  "prescricao",
  "vacinas",
  "termos",
]);

function isValidTabSegment(segment: string | undefined): boolean {
  return segment === undefined || MEDICAL_RECORD_TAB_SLUGS.has(segment);
}

/**
 * True when moving only between tabs on the same new-consultation or edit-consultation route.
 */
export function isMedicalRecordInternalTabNavigation(fromPathname: string, toPathname: string): boolean {
  if (fromPathname === toPathname) return true;

  const createRe = /^\/patients\/pets\/([^/]+)\/medical-records\/new(?:\/([^/]+))?$/;
  const fromCreate = fromPathname.match(createRe);
  const toCreate = toPathname.match(createRe);
  if (fromCreate && toCreate && fromCreate[1] === toCreate[1]) {
    return isValidTabSegment(fromCreate[2]) && isValidTabSegment(toCreate[2]);
  }

  const editRe = /^\/medical-records\/([^/]+)\/edit(?:\/([^/]+))?$/;
  const fromEdit = fromPathname.match(editRe);
  const toEdit = toPathname.match(editRe);
  if (fromEdit && toEdit && fromEdit[1] === toEdit[1]) {
    return isValidTabSegment(fromEdit[2]) && isValidTabSegment(toEdit[2]);
  }

  return false;
}

export function resolveNavigationPathname(to: unknown, fromPathname: string): string | null {
  if (typeof to !== "string" && (typeof to !== "object" || to === null)) {
    return null;
  }
  try {
    return resolvePath(to as To, fromPathname).pathname;
  } catch {
    return null;
  }
}
